<template>
    <div>
        <div class="list_all">
            <div
                @click="jumpDetail(item)"
                class="item clearfix"
                v-for="(item, idx) in itemList"
                :key="idx"
            >
                <div class="left fl">
                    <p>{{ formatDay(item.createTime) }}</p>
                    <span>{{ formatYears(item.createTime) }}</span>
                </div>
                <div class="right fl">
                    {{ item.title }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
   computed: {
     formatDay() {
       return (n) => {
         return n.slice(8,10)
       }
     },
     formatYears() {
       return (n) => {
         return n.slice(0,7)
       }
     }

   },
    props: {
        itemList: {
            type: Array,
        },
    },
    methods: {
        jumpDetail(item) {
            this.$router.push({
                path: "detail",
                query: {
                    titleName: this.$route.query.titleName,
                    detailObj: item
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/mixin.scss";
.list_all {
    .item {
        height: narrow(80);
        margin-bottom: 20px;
        cursor: pointer;
        .left {
            box-sizing: border-box;
            width: narrow(75);
            height: narrow(80);
            padding-top: 24px;
            background-color: #014f98;
            font-size: narrow(26);
            color: #fff;
            text-align: center;
            line-height: narrow(24);
            span {
                font-size: 12px;
            }
        }
        .right {
            box-sizing: border-box;
            width: 1087px;
            height: narrow(80);
            line-height: narrow(80);
            background-color: #f5f6f8;
            padding-left: narrow(15);
            font-size: 16px;
            color: #333;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Listitem.vue